import { Fancybox } from "@fancyapps/ui";
import { initForms, initFormSelects, initCtaFormPopups, initAjaxFormSubmission } from "./form";

const initFormsInContainer = (container) => {
  if (!container) {
    return;
  }

  container.querySelectorAll("form[data-ajax-initialized]").forEach((form) => {
    delete form.dataset.ajaxInitialized;
  });
  container.querySelectorAll("form[data-form-initialized]").forEach((form) => {
    delete form.dataset.formInitialized;
  });
  container.querySelectorAll(".cta-form-popup[data-cta-initialized]").forEach((popup) => {
    delete popup.dataset.ctaInitialized;
  });
  container.querySelectorAll("form[data-cta-popup-form]").forEach((form) => {
    delete form.dataset.ctaPopupForm;
  });

  initForms();
  initFormSelects();
  initCtaFormPopups();
  initAjaxFormSubmission();
};

const IMAGE_URL = /\.(jpe?g|png|gif|webp|svg|avif|bmp)(\?.*)?$/i;
const VIDEO_URL = /\.(mp4|webm|ogg)(\?.*)?$/i;

const getLightboxType = (src) => {
  if (!src || src.startsWith("#") || src.startsWith("javascript:")) {
    return null;
  }

  if (IMAGE_URL.test(src)) {
    return "image";
  }

  if (VIDEO_URL.test(src)) {
    return "html5video";
  }

  if (/\.pdf(\?.*)?$/i.test(src)) {
    return "pdf";
  }

  if (/^https?:\/\//i.test(src)) {
    return "iframe";
  }

  return null;
};

const ensureLightboxAttributes = () => {
  document.querySelectorAll("a.btn-lightbox").forEach((link) => {
    if (!link.hasAttribute("data-fancybox")) {
      link.setAttribute("data-fancybox", "");
    }

    if (link.hasAttribute("data-type")) {
      return;
    }

    const src = link.getAttribute("data-src") || link.getAttribute("href") || "";
    const type = getLightboxType(src);

    if (!type) {
      return;
    }

    link.setAttribute("data-type", type);

    if (type === "iframe" && !link.hasAttribute("data-width")) {
      link.setAttribute("data-width", "90%");
      link.setAttribute("data-height", "90%");
    }
  });
};

export const initLightbox = () => {
  ensureLightboxAttributes();

  Fancybox.unbind("[data-fancybox]");
  Fancybox.close();

  Fancybox.bind("[data-fancybox]", {
    Carousel: {
      Panzoom: false,
      Html: {
        autoplay: false,
      },
    },
    on: {
      reveal: (fancybox, slide) => {
        const container = slide?.contentEl || slide?.el || null;

        if (container?.id?.startsWith("cta-form-")) {
          container.classList.add("cta-form-popup");
        }

        initFormsInContainer(container);
      },
    },
  });
};

initLightbox();
